// USP bar: on phones, show one message at a time and move to the next every few seconds
if (!customElements.get('cymbru-usp-bar')) {
  customElements.define(
    'cymbru-usp-bar',
    class CymbruUspBar extends HTMLElement {
      connectedCallback() {
        this.items = Array.from(this.querySelectorAll('.cymbru-usp-bar__item'));
        if (this.items.length < 2) return;
        this.index = 0;
        this.timer = setInterval(() => this.next(), Number(this.dataset.speed || 4) * 1000);
      }

      disconnectedCallback() {
        clearInterval(this.timer);
      }

      next() {
        this.items[this.index].classList.remove('is-active');
        this.index = (this.index + 1) % this.items.length;
        this.items[this.index].classList.add('is-active');
      }
    }
  );
}
